import {
  IPAddressLabel,
  BertConfigFieldMapping as ConfigFieldMapping,
  ETHER_TYPE_LABEL,
  FRAME_LOSS_TYPE,
  IPAddressValue,
  TRANSMIT_INTERFACE_VALUE,
  frameLossIntervalValue,
  vlanConfigValue,
  definedAddressValue,
  sourceAddressFrom,
  DEFAULT_STREAM
} from '../models/model';
import { AGENT_MODEL, TestLayerValue, TestMode, TestTypeValue } from '@nrwl/common-lib';
export const BERT_AGENT_MODEL_CONFIG = {
  id: 'bert_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'BERT',
          outputField: ConfigFieldMapping.ALIAS,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'bert_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        testMode: {
          enabled: true,
          value: TestMode.LOOPBACK,
          outputField: ConfigFieldMapping.TEST_MODE,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        agentTypeSetup: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        layerToTest: {
          enabled: true,
          value: TestLayerValue.L2,
          outputField: ConfigFieldMapping.LAYER_TO_TEST,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        bertPattern: {
          enabled: true,
          value: '2^31-1',
          outputField: ConfigFieldMapping.BERT_PATTERN,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          },
          tabId: 'bert_setup'
        },
        perfTestDuration: {
          enabled: true,
          value: 900,
          outputField: ConfigFieldMapping.BERT_TEST_DURATION,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        customPerfTestDuration: {
          enabled: true,
          value: '00:15:00',
          outputField: ConfigFieldMapping.BERT_TEST_CUSTOM_DURATION,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        testType: {
          enabled: true,
          value: TestTypeValue.BERT,
          outputField: 'testType',
          tabId: 'bert_setup'
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'bert_setup'
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', endTime: 90, isValid: true },
          outputField: ConfigFieldMapping.SCHEDULER,
          tabId: 'bert_setup',
          restoreOnAgentChange: true
        },
        //endpoints
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'bert_endpoints',
          restoreOnAgentChange: true
        },
        engineAInfo: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_A_INFO,
          tabId: 'bert_endpoints',
          restoreOnAgentChange: true
        },
        engineBInfo: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_B_INFO,
          tabId: 'bert_endpoints',
          restoreOnAgentChange: true,
          outputOptional: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'bert_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'bert_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        frameLossInterval: {
          enabled: false,
          value: frameLossIntervalValue.peak,
          outputField: ConfigFieldMapping.FRAME_LOSS_INTERVAL,
          tabId: 'bert_endpoints'
        },
        definedAddress: {
          enabled: true,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEFINED_ADDRESS,
          tabId: 'bert_endpoints'
        },
        sourceAddressFrom: {
          enabled: true,
          value: sourceAddressFrom.MANUAL,
          outputField: ConfigFieldMapping.SOURCE_ADDRESS_FROM,
          tabId: 'bert_endpoints'
        },
        suppressLoopCommands: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.SUPPRESS_LOOP_COMMANDS,
          tabId: 'bert_endpoints'
        },
        swapMacAddress: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.SWAP_MAC_ADDRESS,
          tabId: 'bert_endpoints'
        },
        sendPrimingPackets: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.SEND_PRIMING_PACKETS,
          tabId: 'bert_endpoints'
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          tabId: 'bert_endpoints'
        },
        etherType: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.ETHER_TYPE,
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 }
            ]
          },
          tabId: 'bert_endpoints'
        },
        cvlanEthertype: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.CVLAN_ETHER_TYPE,
          tabId: 'bert_endpoints'
        },
        vlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SVLAN_ID,
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        cvlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.CVLAN_ID,
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        verifyVlanPriority: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.VERIFY_PRIORITY,
          tabId: 'bert_endpoints'
        },
        transmitInterface: {
          enabled: true,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.TRANSMIT_INTERFACE,
          tabId: 'bert_endpoints'
        },
        srcEditLayer2IP: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_2_IP,
          tabId: 'bert_endpoints'
        },
        srcEditLayer3IP: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_3_IP,
          tabId: 'bert_endpoints'
        },
        srcEditLayer2MAC: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_2_MAC,
          tabId: 'bert_endpoints'
        },
        srcEditLayer3MAC: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.SRC_EDIT_LAYER_3_MAC,
          tabId: 'bert_endpoints'
        },
        srcMACAddress: {
          enabled: true,
          value: '00:11:22:33:44:55',
          outputField: ConfigFieldMapping.SRC_MAC_ADDRESS,
          tabId: 'bert_endpoints'
        },
        srcNetworkMacAddress: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_NETWORK_MAC,
          lookup: ["capabilities.phy['network-mac']"],
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        srcEquipmentMacAddress: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_EQUIPMENT_MAC,
          lookup: ["capabilities.phy['equipment-mac']"],
          tabId: 'bert_endpoints',
          outputOptional: true
        },

        srcTestIpAddress: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_TEST_IP_ADDRESS,
          lookup: ["capabilities.phy['test-ip']"],
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        srcAssignedIpAddress: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_ASSIGNED_IP_ADDRESS,
          lookup: ["capabilities.phy['assigned-ip']"],
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        srcIpV4Address: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_IPV4_ADDRESS,
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        srcSubnet: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_SUBNET,
          lookup: ['capabilities.phy.subnet'],
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        srcGateway: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_GATEWAY,
          lookup: ['capabilities.phy.gateway'],
          tabId: 'bert_endpoints',
          outputOptional: true
        },
        destTransmitInterface: {
          enabled: true,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.DEST_TRANSMIT_INTERFACE,
          tabId: 'bert_endpoints'
        },
        destDefinedAddress: {
          enabled: true,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEST_DEFINED_ADDRESS,
          tabId: 'bert_endpoints',
          restoreOnAgentChange: true
        },
        destEditIP: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_EDIT_IP,
          tabId: 'bert_endpoints'
        },
        destEditMAC: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_EDIT_MAC,
          tabId: 'bert_endpoints'
        },
        destMacAddress: {
          enabled: true,
          value: '00:AA:BB:CC:DD:EE',
          outputField: ConfigFieldMapping.DESTINATION_MAC,
          lookup: ["capabilities.phy['test-mac-address']"],
          tabId: 'bert_endpoints'
        },
        destIPV4Address: {
          enabled: true,
          value: '192.168.1.2',
          outputField: ConfigFieldMapping.DEST_IPV4_ADDRESS,
          lookup: ["capabilities.phy['default-test-ip']"],
          tabId: 'bert_endpoints'
        },
        remoteVlanTagCount: {
          enabled: false,
          value: '0',
          outputField: ConfigFieldMapping.REMOTE_VLAN_TAG,
          tabId: 'bert_endpoints'
        },
        destShowIpLayer2: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_SHOW_IP_LAYER2,
          tabId: 'bert_endpoints'
        },
        destShowMacLayer3: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.DEST_SHOW_MAC_LAYER3,
          tabId: 'bert_endpoints'
        },
        useARPtoLearnMac: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.USE_ARP,
          tabId: 'bert_endpoints'
        },

        //streams models
        deviceSelectionMethod: {
          enabled: true,
          value: 'MAC',
          outputField: ConfigFieldMapping.DEVICE_SELECTION_METHOD,
          tabId: 'bert_streams'
        },
        streams: {
          enabled: true,
          value: DEFAULT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'bert_streams'
        },
        maxServices: {
          enabled: true,
          value: 1,
          outputField: ConfigFieldMapping.MAX_SERVICES,
          tabId: 'bert_streams'
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['bert']['max-bandwidth']"],
          tabId: 'bert_streams',
          outputOptional: true
        },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 64,
              maxValue: 9600,
              selectedVlans: 0,
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'bert_streams'
        },
        validFrameSizesSingle: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],

              minValue: 64,
              maxValue: 9596,
              selectedVlans: 0
            },
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE,
          tabId: 'bert_streams',
          outputOptional: true
        },
        validFrameSizesDouble: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 64,
              maxValue: 9592,
              selectedVlans: 0
            },
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE,
          tabId: 'bert_streams',
          outputOptional: true
        },
        sptFrameSize: {
          enabled: true,
          value: [512],
          outputField: ConfigFieldMapping.BERT_FRAME_SIZE,
          tabId: 'bert_streams',
          restoreOnAgentChange: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    },
    [AGENT_MODEL.JMEP_10G]: {
      setup: {
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          }
        },
        frameLossInterval: {
          enabled: true
        },
        swapMacAddress: {
          enabled: true
        },
        sendPrimingPackets: {
          enabled: true
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          lookup: ["capabilities['bert']['max-bandwidth']"],
          tabId: 'bert_streams',
          outputOptional: true
        },
        vlanId: {
          enabled: true,
          lookup: ["capabilities.phy['test-vlan-id']"]
        },
        vlanDefinedForEachService: { enabled: false },
        etherTypeDefinedForEachService: { enabled: false },
        cvlanEthertype: { enabled: true },
        transmitInterface: { enabled: true },
        definedAddress: { enabled: true },
        srcEditLayer2IP: { enabled: true },
        srcEditLayer3IP: { enabled: true },
        srcEditLayer2MAC: { enabled: false },
        srcEditLayer3MAC: { enabled: false },
        srcNetworkMacAddress: { enabled: true },
        srcEquipmentMacAddress: { enabled: true },
        srcMACAddress: { enabled: false },
        srcTestIpAddress: { enabled: true },
        srcAssignedIpAddress: { enabled: true },
        srcSubnet: { enabled: true },
        srcGateway: { enabled: true },
        remoteVlanTagCount: { enabled: false },
        destShowIpLayer2: { enabled: true },
        destShowMacLayer3: { enabled: true },
        useARPtoLearnMac: { enabled: true },
        svlanPriority: { enabled: true },
        cvlanPriority: { enabled: true },
        verifyVlanPriority: { enabled: true },
        errorOnOOS: { enabled: true },
        overheadBytes: { enabled: true },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 200, enable: false }
              ],
              minValue: 64,
              maxValue: 9600,
              selectedVlans: 0
            },
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'bert_streams'
        },
        validFrameSizesSingle: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],

              minValue: 64,
              maxValue: 9596,
              selectedVlans: 0
            },
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE,
          tabId: 'bert_streams',
          outputOptional: true
        },
        validFrameSizesDouble: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              sptFrameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1522, value: 1522, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 64,
              maxValue: 9592,
              selectedVlans: 0
            },
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE,
          tabId: 'bert_streams',
          outputOptional: true
        },
        streams: {
          enabled: true,
          value: DEFAULT_STREAM,
          outputField: ConfigFieldMapping.STREAMS,
          tabId: 'bert_streams'
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      },
      modes: {
        [TestMode.LOOPBACK]: {
          setup: {
            suppressLoopCommands: { enabled: true },
            engineBInfo: { enabled: true }
          }
        }
      }
    }
  }
};
